/**
 * Updates the recently viewed products in localStorage.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products in session storage */
  static #STORAGE_KEY = 'viewedProducts';
  /** @static @constant {number} The maximum number of products to store */
  static #MAX_PRODUCTS = 4;

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID of the product to add.
   */
  static addProduct(productId) {
    let viewedProducts = this.getProducts();

    viewedProducts = viewedProducts.filter((/** @type {string} */ id) => id !== productId);
    viewedProducts.unshift(productId);
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

    /* GLDN: Safari Private guard (Bug #3) — localStorage throws in iOS WebView / Safari Private */
    try {
      localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
    } catch (e) {
      console.warn('localStorage unavailable for key', this.#STORAGE_KEY, e);
    }
  }

  static clearProducts() {
    /* GLDN: Safari Private guard (Bug #3) */
    try {
      localStorage.removeItem(this.#STORAGE_KEY);
    } catch (e) {
      console.warn('localStorage unavailable for key', this.#STORAGE_KEY, e);
    }
  }

  /**
   * Retrieves the list of recently viewed products from session storage.
   * @returns {string[]} The list of viewed products.
   */
  static getProducts() {
    /* GLDN: Safari Private guard (Bug #3) — return [] when storage throws */
    try {
      return JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
    } catch (e) {
      console.warn('localStorage unavailable for key', this.#STORAGE_KEY, e);
      return [];
    }
  }
}
